import React from 'react';
import RadioButton from '@service-victoria/component-library/components/RadioButton';
import { TravelReason } from 'interfaces/common';
import * as Styled from '../../styled';
import { useAppContext } from 'context/app';
import { useField } from 'formik';

export const TravelReasonSelector: React.FC<Record<string, never>> = () => {
  const {
    currentState: { travelReasons }
  } = useAppContext();
  const [{ value: zone }] = useField<string>('assess.travelZone');

  if (travelReasons.status !== 'success') return null;

  const mappedReasonsForZone = getMappedReasonsForZone(zone, travelReasons.reasons);

  if (mappedReasonsForZone.length <= 1) return null;

  return (
    <>
      <Styled.Spacer16 />
      <Styled.RadioContainer>
        <RadioButton
          groupLabel=''
          items={mappedReasonsForZone}
          name='assess.reasons'
          aria-labelledby='assess.reasons.label'
          errorLabelProps={{
            'data-testid': 'TravelReason-RadioButtonError'
          }}
        />
      </Styled.RadioContainer>
    </>
  );
};

function getMappedReasonsForZone(zone: string, travelReasons: TravelReason[]) {
  let reasonsForZone = travelReasons.filter(reason => reason.zone === zone) || [];

  // Annoying workaround since UX team want travel reason for specified workers to be different only here
  if (zone === 'worker') {
    reasonsForZone = reasonsForZone.map(reason =>
      Object.assign({}, reason, { label: capitalize(reason.label.split(':').slice(-1)[0].trim()) })
    );
  }

  return reasonsForZone.map(reason => ({
    ...reason,
    inputProps: {
      'data-testid': `Reason-${reason.value}-RadioButton`
    }
  }));
}

function capitalize(text: string) {
  return text[0].toUpperCase() + text.slice(1);
}
